import * as api from 'service/ErplyAPI/vatRates';
import { addError } from 'rdx/alert';

import * as types from './types';

export const fetchVatRates =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: types.FETCH_VAT_RATES.START });
    try {
      const vatRates = await api.getVatRates(params);
      dispatch({
        type: types.FETCH_VAT_RATES.SUCCESS,
        payload: vatRates.records,
      });
    } catch (error) {
      dispatch(addError(error.message));
    }
  };

export const saveVatRate = (params) => async (dispatch) => {
  dispatch({ type: types.SET_VAT_RATES.START });
  try {
    const { records } = await api.saveVatRate(params);
    const { vatRateID } = records[0];
    dispatch({
      type: types.SET_VAT_RATES.SUCCESS,
      payload: { ...params, id: vatRateID },
    });
  } catch (err) {
    dispatch(addError(err.message));
    dispatch({ type: types.SET_VAT_RATES.ERROR, payload: err.message });
  }
};
